class OpenDataCarto extends google.maps.OverlayView {

    constructor(types) {
        super();

        this.types = types;
        this.data = [];
        this.drawRequestId = 0;
    }

    get minZoom() {
        return 11;
    }

    get baseUrl() {}

    get geoField() {}

    hide() {
        const map = this.getMap();
        this.data.forEach(feature => map.data.remove(feature));
        this.setMap(null);
        google.maps.event.removeListener(this.dragendListener);
        google.maps.event.removeListener(this.zoomChangedListener);
    };

    onRemove() {
        this.drawRequestId++;
        this.data = [];
        google.maps.event.removeListener(this.dragendListener);
        google.maps.event.removeListener(this.zoomChangedListener);
    }

    onAdd() {
        window.FreezeUI({selector: "#map"});
        this.drawData();
        this.dragendListener = google.maps.event.addListener(this.getMap(), 'dragend', this.boundsUpdated(500).bind(this));
        this.zoomChangedListener = google.maps.event.addListener(this.getMap(), 'zoom_changed', this.boundsUpdated(1000).bind(this));
    }

    drawData() {
        const drawRequestId = ++this.drawRequestId;
        const zoomLevel = this.getMap().getZoom();
        if (zoomLevel < this.minZoom) {
            window.UnFreezeUI({selector: "#map"});
            return;
        }

        this.initFilter();
        const promises = [];
        for (let type of this.types) {
            const promise = this.fetchGeoJson(type)
                .then(json => {
                    if (!this.getMap() || drawRequestId !== this.drawRequestId) {
                        return;
                    }

                    const data = this.getMap().data.addGeoJson(json);
                    this.data.push(...data);
                    data.forEach(feature => {
                        this.overrideStyle(feature)
                    });
                });

            promises.push(promise);
        }
        Promise.all(promises)
            .catch(error => console.error('Impossible de charger un calque Open Data.', error))
            .finally(() => window.UnFreezeUI({selector: "#map"}))
    }

    fetchGeoJson(type) {
        const url = `${this.baseUrl}/api/explore/v2.0/catalog/datasets/${type}/exports/geojson?where=${this.encodedFilter}`;

        return fetch(url).then(response => {
            if (!response.ok) {
                throw new Error(`${response.status} ${response.statusText} (${url})`);
            }

            return response.json();
        });
    }

    initFilter() {
        const bounds = this.getMap().getBounds().toJSON();
        const bbox = [bounds.west, bounds.south, bounds.east, bounds.north];
        const bboxPolygon = turf.bboxPolygon(bbox);
        this.encodedFilter = `geometry(${this.geoField}, geom'${JSON.stringify(bboxPolygon.geometry)}')`;
    }

    boundsUpdated(delay) {
        return () => {
            if (this.timeout) {
                window.clearTimeout(this.timeout);
            }
    
            this.timeout = window.setTimeout(() => {
                window.FreezeUI({selector: "#map"});
                this.data.forEach(feature => this.getMap().data.remove(feature));
                this.data = [];
                this.drawData(true);
            }, delay);
        }
    }

    overrideStyle(feature) {};

    setOpacity(opacity) {
        this.opacity = opacity;
        if (this.getMap()) {
            this.data.forEach(feature => this.overrideStyle(feature));
        }
    }

    getOpacity() {
        return this.opacity;
    }

}

export default OpenDataCarto;
